import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "symbol symbol-50px" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Examine")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CardTable = _resolveComponent("CardTable")!

  return (_openBlock(), _createBlock(_component_CardTable, {
    ref: "tableRef",
    name: "Partner",
    modelValue: $setup.data,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data) = $event)),
    header: $setup.tableHeader,
    breadcrumbs: $setup.breadcrumbs,
    loadingProp: $setup.loading,
    canCreate: false
  }, {
    "cell-no": _withCtx(({ index }) => [
      _createTextVNode(_toDisplayString(index + 1), 1)
    ]),
    "cell-profileImage": _withCtx(({ row }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "custom-image-box",
          style: _normalizeStyle(`background-image: url('${
            row.profileImage || 'media/images/steam-question-mark-icon-29.jpg'
          }')`)
        }, null, 4),
        false
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: 
            row.profileImage ||
            'https://www.seekpng.com/png/detail/414-4140251_you-profile-picture-question-mark.png'
          ,
              alt: "Picture"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ])
    ]),
    "cell-details": _withCtx(({ row }) => [
      _createVNode(_component_router_link, {
        style: {"min-width":"114px"},
        class: "btn px-8 py-2 text-uppercase btn-primary",
        to: `verify/${row.id}?role=${row.role || row.type}`
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    "cell-name": _withCtx(({ row }) => [
      _createTextVNode(_toDisplayString(row.name || '-'), 1)
    ]),
    "cell-createdAt": _withCtx(({ row }) => [
      _createTextVNode(_toDisplayString($setup.moment(row.createAt).format('DD/MM/YYYY') || '-'), 1)
    ]),
    "cell-role": _withCtx(({ row }) => [
      _createTextVNode(_toDisplayString(row.role || row.type), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "header", "breadcrumbs", "loadingProp"]))
}